const rawBase = process.env.REACT_APP_SITE_DOMAIN || '';
const MEDIA_BASE_URL = rawBase.replace(/\/+$/, '');
const IS_DEV = process.env.NODE_ENV === 'development';

export function resolveMediaUrl(input) {
  if (!input) return input;

  const value = String(input);

  if (/^https?:\/\//i.test(value) || value.startsWith('data:') || value.startsWith('blob:')) {
    return value;
  }

  // En dev local, /assets_react/... est servi directement par le dev server depuis public/ :
  // on ne veut JAMAIS pointer vers la prod pour ces fichiers, sinon un fichier présent dans le
  // repo mais pas encore déployé (ou l'inverse) est invisible depuis le poste du dev.
  // Tout autre chemin (hors /assets_react/) est lu sur la prod.
  if (IS_DEV && value.startsWith('/assets_react/')) {
    return value;
  }

  if (!MEDIA_BASE_URL) {
    return value;
  }

  if (value.startsWith('/')) {
    return `${MEDIA_BASE_URL}${value}`;
  }

  return `${MEDIA_BASE_URL}/${value}`;
}

// Returns the demo preview path for a visual filename (e.g. "tulipes.jpg" → "/assets_react/demos/demo_tulipes.jpg").
// Falls back gracefully via <img onError> in the UI.
export function getDemoPath(visuel) {
  if (!visuel) return '';
  return `/assets_react/demos/demo_${visuel}`;
}

// Returns the raw visual path as fallback when no demo image exists.
export function getVisuelPath(visuel) {
  if (!visuel) return '';
  return `/assets_react/visuels/${visuel}`;
}
